import React from "react";
import { useRouteMatch } from "react-router-dom";
import ApiResponse from "../Common/ApiResponse";
import FeedbackForm from "./FeedbackForm";
import { StyledAvatar } from "./StyledAvatar";
import emailjs from "emailjs-com";
import sujoy from "../../images/sujoy3.jpg";
import sounak from "../../images/sounak.PNG";
import basu from "../../images/basu.jpg";
import sourima from '../../images/sourima.jpeg'

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(() => ({
  container: {
    padding: "1rem",
  },
  devList: {
    display: "flex",
    marginTop: "1rem",
    marginBottom: "1rem",
  },
}));

export default function About({ setCurrentPath }) {
  const [email, setEmail] = React.useState("");
  const [feedback, setFeedback] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState({
    type: null,
    message: null,
  });
  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [snackbarType, setSnackbarType] = React.useState("");
  const classes = useStyles();
  const match = useRouteMatch();

  const openSnackbar = (m, t) => {
    setMessage(m);
    setSnackbarType(t);
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  React.useEffect(() => {
    setCurrentPath(match.path);
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();

    if (email === "") {
      window.navigator.vibrate(200);
      setErrorMessage({
        type: "email",
        message: "Please enter email",
      });
      return;
    } else if (
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        email
      ) === false
    ) {
      window.navigator.vibrate(200);
      setErrorMessage({
        type: "email",
        message: "Please provide valid email",
      });
      return;
    } else if (feedback === "") {
      window.navigator.vibrate(200);
      setErrorMessage({
        type: "feedback",
        message: "Cannot send Empty message",
      });
      return;
    }
    setErrorMessage({
      type: null,
      message: null,
    });

    emailjs
      .sendForm(
        "service_qrhsi27",
        "template_q7q1lt9",
        e.target,
        "user_oqPlKCDqQ4cyxDmKySBcb"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );

    openSnackbar("Message sent", "info");
    setEmail("");
    setFeedback("");
  };

  return (
    <Grid container>
      <Grid item sm={2} xs={false}></Grid>
      <Grid item sm={8} xs={12}>
        <div className={"header-space"}></div>
        <Grid container className={classes.container}>
          <Grid item>
            <Typography variant="h5" color="secondary">
              Minds behind the website
            </Typography>
          </Grid>
          <Grid container className={classes.devList}>
            <StyledAvatar
              name="Sounak Pal"
              imgUrl={sounak}
              instaUrl="https://www.instagram.com/sounak.pal/"
              gitHubUrl="https://github.com/GamerBoy2K"
            />
            <StyledAvatar
              name="Sujoy Ghosh"
              imgUrl={sujoy}
              instaUrl="https://www.instagram.com/hayitsscott/"
              gitHubUrl="https://github.com/SujoyGhosh-scott"
            />
            <StyledAvatar
              name="Sreshtha Basu"
              imgUrl={basu}
              instaUrl="https://www.instagram.com/miss.basu_/"
              gitHubUrl="https://github.com/sresh-b"
            />
            <StyledAvatar name="Sourima Saha" imgUrl={sourima} instaUrl={null} gitHubUrl={null} />
          </Grid>
          <FeedbackForm
            email={email}
            setEmail={setEmail}
            feedback={feedback}
            setFeedback={setFeedback}
            errorMessage={errorMessage}
            sendEmail={sendEmail}
          />
        </Grid>
        <div className={"footer-space"}></div>
        <ApiResponse
          open={open}
          handleClose={handleClose}
          message={message}
          snackbarType={snackbarType}
        />
      </Grid>
      <Grid item sm={2} xs={false}></Grid>
    </Grid>
  );
}
